import { format } from 'date-fns';
import styled from 'styled-components';

import ChevronLeft from 'svg/ChevronLeft';

import useDayNavigation from '../hooks/useDayNavigation';

export default function DayDateNavigation() {
  const { startDate, goToNextDay, goToPreviousDay, goToToday, canGoNext, canGoPrevious } = useDayNavigation();

  const formatDate = () => {
    return format(startDate, 'EEEE, MMMM do, yyyy');
  };

  return (
    <Container>
      <ArrowGroup>
        <NavArrow onClick={goToPreviousDay} disabled={!canGoPrevious} data-cy='nav-previous-day'>
          <ChevronLeft width={10} height={10} />
        </NavArrow>
        <NavArrow onClick={goToNextDay} disabled={!canGoNext} aria-label='Next day' data-cy='nav-next-day'>
          <MirroredChevron width={10} height={10} />
        </NavArrow>
      </ArrowGroup>

      <DateLabel data-cy='date-label'>{formatDate()}</DateLabel>

      <TodayLink onClick={goToToday} data-cy='nav-today'>
        Today
      </TodayLink>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const ArrowGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const MirroredChevron = styled(ChevronLeft)`
  transform: scaleX(-1);
`;

const NavArrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.black100};
  cursor: pointer;
  padding: 0;

  &:hover:not(:disabled) {
    opacity: 0.7;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

const DateLabel = styled.span`
  font-size: 14px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black100};
`;

const TodayLink = styled.button`
  font-size: 12px;
  font-weight: var(--font-weight-medium);
  color: ${({ theme }) => theme.colors.black100};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black25};
  border-radius: 4px;
  padding: 8px 16px;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.black5};
  }
`;
